export var DeviceVaultOperation;
(function (DeviceVaultOperation) {
    DeviceVaultOperation[DeviceVaultOperation["NoOp"] = 0] = "NoOp";
    DeviceVaultOperation[DeviceVaultOperation["AddGroup"] = 1] = "AddGroup";
    DeviceVaultOperation[DeviceVaultOperation["RemoveGroup"] = 2] = "RemoveGroup";
    DeviceVaultOperation[DeviceVaultOperation["AddPolicy"] = 3] = "AddPolicy";
    DeviceVaultOperation[DeviceVaultOperation["RemovePolicy"] = 4] = "RemovePolicy";
})(DeviceVaultOperation || (DeviceVaultOperation = {}));
